module.exports = __webpack_public_path__ + "img/youshi12.5890332e.png";